import { useContext, useState } from "react";
import IdCell from "layouts/breathe/breathe-list/components/IdCell";
import DefaultCell from "layouts/breathe/breathe-list/components/DefaultCell";

import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import { NavLink } from "react-router-dom";
import { DataContext } from "context/dataContext";
import SnackbarAlert from "components/SnackbarAlert";
import DeleteConfirmationPopover from "components/DeleteConfirmationPopover";

const dataTableData = {
  columns: [
    {
      Header: "ID",
      accessor: "id",
      width: 100,
      link: "/breathe/edit-breathe/",
      linkByID: true,
      Cell: ({ value }) => <IdCell id={value.toUpperCase()} />,
    },
    {
      Header: "Name",
      accessor: "name",
      link: "/breathe/edit-breathe/",
      linkByID: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Slug",
      accessor: "slug",
      linkByID: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Category",
      accessor: "category",
      linkByID: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Type",
      accessor: "type",
      linkByID: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Actions",
      accessor: "actions",
      width: 10,
      align: "right",
      Cell: ({ row }) => {
        const { deleteSingleBreatheApi } = useContext(DataContext);

        return (
          <>
            <MDBox display="flex" gap={2}>
              <MDButton
                size="small"
                variant="gradient"
                color="primary"
                component={NavLink}
                to={`/breathe/edit-breathe/${row.original.id}`}
              >
                Edit
              </MDButton>
              <DeleteConfirmationPopover
                heading="are you sure?"
                buttonText="Delete"
                DeleteFunction={() => {
                  deleteSingleBreatheApi(row.original.id);
                }}
              />
            </MDBox>
          </>
        );
      },
    },
  ],

  rows: [],
};

export default dataTableData;
